import { CloudUpload } from "lucide-react";
import { useRef } from "react";

import { Button } from "@/components/kit";
import { Chip, MOODS, PlayButton } from "@/components/create/pickers";
import { cn } from "@/lib/utils";

export function MusicPicker({ mood, source, tracks, selTrack, onMood, onUploadMode, onTrack, preview, custom, customProgress, onPickFile }) {
  const input = useRef(null);
  return (
    <div className="flex flex-col gap-3">
      <div className="-mx-4 flex gap-2 overflow-x-auto px-4 pb-1 sm:mx-0 sm:flex-wrap sm:px-0" role="group" aria-label="Music mood">
        {MOODS.map((m) => (
          <Chip key={m.v} label={m.label} selected={source === "builtin" && mood === m.v} onClick={() => onMood(m.v)} data-testid={`music-mood-${m.v}`} />
        ))}
        <Chip label="My track" icon selected={source === "upload"} onClick={onUploadMode} data-testid="music-mood-upload" />
      </div>
      {source === "builtin" ? (
        <ul className="flex flex-col gap-2" data-testid="music-track-list">
          {tracks.map((t) => {
            const on = selTrack === t.track_id;
            return (
              <li key={t.track_id} className={cn("flex min-h-14 items-center gap-3 rounded-xl border p-2 pl-3 transition-colors",
                on ? "border-primary bg-primary/15" : "border-border bg-card hover:border-primary/40")}>
                <button type="button" role="radio" aria-checked={on} onClick={() => onTrack(t.track_id)} data-testid={`music-track-${t.track_id}`}
                  className="focus-ring flex min-h-10 flex-1 items-center gap-3 rounded-md text-left">
                  <span className={cn("flex h-5 w-5 shrink-0 items-center justify-center rounded-full border-2 border-primary")} aria-hidden>
                    {on ? <span className="h-2.5 w-2.5 rounded-full bg-primary" /> : null}
                  </span>
                  <span className="text-sm font-medium">{t.title}</span>
                </button>
                <PlayButton playing={preview.playing === t.track_id} label={`${t.title} preview`}
                  onClick={() => preview.toggle(t.track_id, t.preview_url)} data-testid={`music-preview-${t.track_id}`} />
              </li>
            );
          })}
        </ul>
      ) : (
        <>
          <Button variant="secondary" icon={CloudUpload} disabled={customProgress !== null} onClick={() => input.current?.click()}
            title={customProgress !== null ? `Uploading ${Math.round(customProgress * 100)}%` : custom ? `Change track (${custom.name})` : "Upload your own track"}
            data-testid="music-upload-button" />
          <input ref={input} type="file" accept="audio/*" className="sr-only" tabIndex={-1} aria-hidden data-testid="music-file-input"
            onChange={(e) => { const f = e.target.files?.[0]; e.target.value = ""; if (f) onPickFile(f); }} />
        </>
      )}
    </div>
  );
}
